import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BootClosedIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M20.0001 8.61964L19.1871 8.15961C18.2419 7.57324 17.1596 7.2627 16.0552 7.2627L11.76 7.26364C11.1846 7.29112 10.6178 7.41641 10.0824 7.63407L3.9939 10.2031V15.4951L6.55092 16.6567C7.54336 19.9753 11.4681 19.7447 12.4652 17.1535H20.0001V15.3535H12.4652H11.2291L10.7853 16.5071C10.5816 17.0363 10.083 17.3362 9.55501 17.3219C9.11621 17.3101 8.55291 17.0687 8.27546 16.141L8.04086 15.3565L7.29539 15.0179L5.7939 14.3358V11.3973L10.7701 9.29759C11.1032 9.1634 11.4533 9.0847 11.8078 9.06363L16.0552 9.0627H16.0556H16.0556C16.821 9.06277 17.5751 9.27778 18.2382 9.68917L18.269 9.70831L18.3006 9.72618L20.0001 10.6878V8.61964Z"
      />
    </SvgIcon>
  );
});
